import { ScheduledBackupDto, ScheduledPruneDto, type ScheduledValidatorIdDumpDto } from 'data';
import { dayTimeFormatFromUnix } from './date-parsers';

export const getNextRunDate = (data?: ScheduledPruneDto | ScheduledBackupDto | ScheduledValidatorIdDumpDto) =>
  data?.nextRun ? dayTimeFormatFromUnix(data.nextRun) : '';
